import { CloudUploadOutlined } from "@ant-design/icons";
import { Form, Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useImport } from "@/hooks/importToolXSLX";

import { useImportContext } from "./ImportContext";
import {
  formatErrorsAlerts,
  formatInsertSuccessAlert,
  formatUpdateSuccessAlert,
} from "./uploadUtils";

const ImportButton = ({ filePath, onSetAlerts, onSetFilePath }) => {
  const { t } = useTranslation();
  const { model, modelName, operation } = useImportContext();
  const { loading: isImporting, handleImport } = useImport();

  const importFile = async () => {
    const { status, data, errors } = await handleImport(
      model,
      filePath,
      operation
    );
    if (status === "success") {
      const { inserted, updated, ignored } = data;
      const alert =
        operation === "insert"
          ? formatInsertSuccessAlert(inserted.length)
          : formatUpdateSuccessAlert(updated.length, ignored.length);

      onSetAlerts(alert);
      onSetFilePath(null);
    } else if (errors && Object.keys(errors).length > 0) {
      const alerts = formatErrorsAlerts(errors);
      onSetAlerts(alerts);
    }
  };

  return (
    <Form.Item>
      <Button
        loading={isImporting}
        disabled={!filePath}
        onClick={importFile}
        icon={<CloudUploadOutlined />}
        style={{ marginTop: "10px" }}
      >
        {t(`importTool:import.${operation}Form.submitButton`, {
          model: modelName,
        })}
      </Button>
    </Form.Item>
  );
};

ImportButton.propTypes = {
  filePath: PropTypes.string,
  onSetAlerts: PropTypes.func.isRequired,
  onSetFilePath: PropTypes.func.isRequired,
};

export default ImportButton;
